import { z } from "zod"
import { SaveCustomerContactDetailsSchema } from "../../customer"
import { TranslationKey } from "../../i18n/translation-key"
import { StandardFeeInfo } from "./maintenance-booking"
import {
  CommonBookingSchema,
  CommonDataRequiredForBooking,
} from "./service-booking"

export enum EmergencyServiceType {
  FLAT_TIRE = "FLAT_TIRE",
  CHAIN_BREAK = "CHAIN_BREAK",
  WIRE_BREAK = "WIRE_BREAK",
}

export const ToggleEmergencyServiceSchema = z.object({
  allowsEmergencyService: z.boolean(),
})

export type ToggleEmergencyService = z.infer<
  typeof ToggleEmergencyServiceSchema
>

export const SaveEmergencyServicePriceSchema = z.object({
  type: z.nativeEnum(EmergencyServiceType),
  price: z.number(),
})

export type SaveEmergencyServicePrice = z.infer<
  typeof SaveEmergencyServicePriceSchema
>

const EMERGENCY_SERVICE_TYPE_LABEL_KEYS: Record<
  EmergencyServiceType,
  TranslationKey
> = {
  [EmergencyServiceType.CHAIN_BREAK]: "common.emergencyService.chainBreak",
  [EmergencyServiceType.FLAT_TIRE]: "common.emergencyService.flatTire",
  [EmergencyServiceType.WIRE_BREAK]: "common.emergencyService.wireBreak",
}

export class EmergencyServiceTypeUtils {
  static toLabelKey(type: EmergencyServiceType): TranslationKey {
    return EMERGENCY_SERVICE_TYPE_LABEL_KEYS[type]
  }
}

export interface DataRequiredForEmergencyBooking
  extends CommonDataRequiredForBooking {
  spotsLeft: {
    today: number
    tomorrow: number
  }
  prices: Record<EmergencyServiceType, number>
  standardFees: {
    emergencyService?: StandardFeeInfo
  }
}

export const BookEmergencyServiceSchema = CommonBookingSchema.extend({
  type: z.nativeEnum(EmergencyServiceType),
  customer: SaveCustomerContactDetailsSchema,
})

export type BookEmergencyService = z.infer<typeof BookEmergencyServiceSchema>
